import { render } from "./VmsSidebarCamerasTabListItemScreenshot.vue?vue&type=template&id=61e90416&ts=true"
import script from "./VmsSidebarCamerasTabListItemScreenshot.vue?vue&type=script&lang=ts"
export * from "./VmsSidebarCamerasTabListItemScreenshot.vue?vue&type=script&lang=ts"

import "./VmsSidebarCamerasTabListItemScreenshot.vue?vue&type=style&index=0&id=61e90416&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__